import { useForceUpdate } from "./useForceUpdate";
export { useForceUpdate };
export default useForceUpdate;
